import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['./error-404.component.css'],
    standalone: false
})
export class Error404Component {

  title = 'BLESS Dashboard';

}
